// @flow
/* eslint-disable sort-keys, max-len */
const { flattenMessages } = require('../utils/flattenMessages');
export default {
    en: flattenMessages(require('./en.js').default),
    'en-gb': flattenMessages(require('./en-gb.js').default),
    de: flattenMessages(require('./de.js').default),
    es: flattenMessages(require('./es.js').default),
    fr: flattenMessages(require('./fr.js').default),
    it: flattenMessages(require('./it.js').default),
    ja: flattenMessages(require('./ja.js').default),
    ko: flattenMessages(require('./ko.js').default),
    nl: flattenMessages(require('./nl.js').default),
    pl: flattenMessages(require('./pl.js').default),
    ru: flattenMessages(require('./ru.js').default),
    zh: flattenMessages(require('./zh.js').default),
};
